import * as Styled from './styled';
import { useState } from 'react';
import ButtonWithArrowRight from '../../../components/dumbs/ButtonWithArrowRight';
import Footer from '../../../components/dumbs/Footer';
import Form from '../../../components/dumbs/Form';
import NotificationBanner from '../../../components/dumbs/NotificationBanner';
import Title from '../../../components/dumbs/Title';

import { Values } from './types';
import validationSchema from './validation';
import { useNavigate } from 'react-router-dom';
import { Representative } from '~services';
import { useRequest } from 'ahooks';
import { useTransshipment } from '~contexts/TranshipmentContext';
import * as amplitude from '@amplitude/analytics-browser';

const numbers = /\d/;
const uppercase = /[A-Z]/;
const lowercase = /[a-z]/;
const specialChars = /_|[^\w]/;

function PasswordCreation() {
  const navigate = useNavigate();
  const transhipment = useTransshipment();

  const { runAsync: createAccountPassword } = useRequest(
    Representative.createAccountPassword,
    {
      manual: true,
    }
  );
  const handleSubmit = async (values: Values) => {
    await createAccountPassword(transhipment.id, {
      password: values.password,
    });

    if (transhipment.type === 'representative') {
      amplitude.track({
        event_type: 'legal_representative_password_created',
        event_properties: {
          CPF_representatives: transhipment.data.cpf,
        },
      });
    }

    navigate(`/transbordo/sucesso`);
  };

  const [isEyeCrossed, setEyeCroos] = useState(false);
  const [isConfirmationCrossed, setConfirmationCross] = useState(false);

  function validate(string) {
    if (
      numbers.test(string) &&
      specialChars.test(string) &&
      uppercase.test(string) &&
      lowercase.test(string)
    )
      return true;
    return false;
  }

  function validateTipsOne({ password }) {
    return !password ? false : validate(password) ? false : true;
  }

  function handleClickPasswordEyeCross() {
    setEyeCroos((prevState) => !prevState);
  }

  function handleClickConfirmationEyeCross() {
    setConfirmationCross((prevState) => !prevState);
  }

  return (
    <Form<Values>
      initialValues={{ password: '', confirmation: '' }}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      aria-labelledby="form-title"
    >
      {({ values }) => {
        return (
          <Styled.MainContainer>
            <Styled.Content>
              <Title id="form-title">
                Agora vamos criar sua senha de acesso
              </Title>
              <Styled.Description variant="sub500">
                Esta será sua senha para acessar sua Conta Fretebras.
              </Styled.Description>
            </Styled.Content>

            <Styled.ExistingAccessNotice id="existing-access-notice">
              <NotificationBanner title="Se você já acessa o Internet Banking com este CPF, use a senha atual. A nova empresa vai aparecer no seu acesso." />
            </Styled.ExistingAccessNotice>

            <Styled.InputPassword
              name="password"
              aria-describedby="existing-access-notice"
              placeholder="Digite sua senha de acesso"
              label="Senha de acesso *"
              type={isEyeCrossed ? 'text' : 'password'}
              trailingIcon={
                isEyeCrossed ? (
                  <Styled.EyeSvg onClick={handleClickPasswordEyeCross} />
                ) : (
                  <Styled.EyeCrossedSvg onClick={handleClickPasswordEyeCross} />
                )
              }
            />

            <Styled.ConfirmPassword
              name="confirmation"
              placeholder="Repita sua senha de acesso"
              label="Confirme sua senha de acesso *"
              type={isConfirmationCrossed ? 'text' : 'password'}
              trailingIcon={
                isConfirmationCrossed ? (
                  <Styled.EyeSvg onClick={handleClickConfirmationEyeCross} />
                ) : (
                  <Styled.EyeCrossedSvg
                    onClick={handleClickConfirmationEyeCross}
                  />
                )
              }
            />

            <Styled.PasswordInfo>
              <Styled.SubTitle variant="caption-bold">
                Para sua segurança:
              </Styled.SubTitle>

              <Styled.InfoSectionOne>
                {!values.password ? (
                  <Styled.ArrowRightPass />
                ) : validate(values.password) ? (
                  <Styled.CheckMark />
                ) : (
                  <Styled.Warning />
                )}
                <Styled.PasswordTipsOne
                  variant="caption-bold"
                  hasError={validateTipsOne(values)}
                >
                  Deve conter um número, uma letra maiúscula, uma letra
                  minúscula e um símbolo
                </Styled.PasswordTipsOne>
              </Styled.InfoSectionOne>

              <Styled.InfoSectionTwo>
                {!values.password ? (
                  <Styled.ArrowRightPass />
                ) : values.password.length >= 8 ? (
                  <Styled.CheckMark />
                ) : (
                  <Styled.Warning />
                )}
                <Styled.PasswordTipsTwo
                  hasError={
                    values.password.length < 8 && values.password.length !== 0
                  }
                  variant="caption-bold"
                >
                  Ter 8 ou mais dígitos
                </Styled.PasswordTipsTwo>
              </Styled.InfoSectionTwo>
            </Styled.PasswordInfo>

            <Footer
              marginTop="auto"
              rightButton={
                <ButtonWithArrowRight
                  width="100%"
                  type="submit"
                  variant="primary"
                >
                  Continuar
                </ButtonWithArrowRight>
              }
            />
          </Styled.MainContainer>
        );
      }}
    </Form>
  );
}

export default PasswordCreation;
